// action nameler uniq olmalı
//auth
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";


//language
export const GET_LANGUAGE_LIST_SUCCESS = "GET_LANGUAGE_LIST_SUCCESS";
export const GET_TRANSLATIONS_SUCCESS = "GET_TRANSLATIONS_SUCCESS";

//menu
export const GET_MENUS_ITEM_SECCUSS = "GET_MENUS_ITEM_SECCUSS";

//languageItem
export const GET_LANGUAGE_ITEM_SECCUSS = "GET_LANGUAGE_ITEM_SECCUSS";
export const GET_LANGUAGE_ITEM_ISTATISTICS_SECCUSS = "GET_LANGUAGE_ITEM_ISTATISTICS_SECCUSS";


// APP
export const SET_LOADING = "SET_LOADING";